import type { TFunction } from "i18next";

export function remaining_period(now: Date, future: Date, t: TFunction) {
    let diffTime = Math.floor((future.getTime() - now.getTime()) / 1000);
    const timeStrSet: string[] = [];
    let remain, interval;

    remain = diffTime % (24 * 60 * 60);
    interval = diffTime / (24 * 60 * 60);
    if (interval >= 1) { // >= 로 수정
        const n = Math.floor(interval);
        timeStrSet.push(t("duration.days", { count: n }));
        diffTime = remain;
    }

    remain = diffTime % (60 * 60);
    interval = diffTime / (60 * 60);
    if (interval >= 1) { // >= 로 수정
        const n = Math.floor(interval);
        timeStrSet.push(t("duration.hours", { count: n }));
        diffTime = remain;
    }

    interval = diffTime / 60;
    if (interval >= 1) { // >= 로 수정
        const n = Math.floor(interval);
        timeStrSet.push(t("duration.minutes", { count: n }));
    }

    return timeStrSet.join(" ");
}
